<template>
  <div>
    <div class="container">
      <div class="row gap-2 mt-3">
        <div class="col-12 col-md-6 col-lg-3 mb-3">
          <b-card
            border-variant="primary"
            header="Total Produk"
            class="custom-card-header"
            align="center"
          >
            <h4 v-if="loaded == true">{{ items.length }}</h4>
            <h4 v-else><b-spinner variant="warning"></b-spinner></h4>
          </b-card>
        </div>
        <div class="col-12 col-md-6 col-lg-3 mb-3">
          <b-card
            border-variant="primary"
            header="Total Pengajuan"
            class="custom-card-header"
            align="center"
          >
            <h4 v-if="loaded == true">{{ total_pengajuan.length }}</h4>
            <h4 v-else><b-spinner variant="warning"></b-spinner></h4>
          </b-card>
        </div>
        <div class="col-12 col-md-6 col-lg-3 mb-3">
          <b-card
            border-variant="primary"
            header="Total Nasabah"
            class="custom-card-header"
            align="center"
          >
            <h4 v-if="loaded == true">{{ total_nasabah }}</h4>
            <h4 v-else><b-spinner variant="warning"></b-spinner></h4>
          </b-card>
        </div>
        <div class="col-12 col-md-6 col-lg-3 mb-3">
          <b-card
            border-variant="primary"
            header="Biaya Jasa (Bulan Ini)"
            class="custom-card-header"
            align="center"
          >
            <h4 v-if="loaded == true">
              Rp.{{ new Intl.NumberFormat('id-ID').format(Number(biaya_jasa)) }}
            </h4>
            <h4 v-else><b-spinner variant="warning"></b-spinner></h4>
          </b-card>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-md-6 mb-3">
          <b-card
            border-variant="primary"
            header="Pengajuan Hari Ini"
            class="custom-card-header"
            align="center"
          >
            <h4 v-if="loaded == true">{{ total_pengajuan_hari_ini.length }}</h4>
            <h4 v-else><b-spinner variant="warning"></b-spinner></h4>
          </b-card>
        </div>
        <div class="col-12 col-md-6 mb-3">
          <b-card
            border-variant="primary"
            header="Pengajuan Dalam Proses"
            class="custom-card-header"
            align="center"
          >
            <h4 v-if="loaded == true">{{ total_pengajuan_proses.length }}</h4>
            <h4 v-else><b-spinner variant="warning"></b-spinner></h4>
          </b-card>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-md-6 mb-3">
          <b-card
            border-variant="primary"
            header="Produk Populer"
            class="custom-card-header"
            align="center"
          >
            <h3
              v-if="loaded == true"
              v-for="(produk, index) in produk_populer"
              :key="index"
            >
              - {{ produk.nama_produk }}
            </h3>
            <h4 v-else><b-spinner variant="warning"></b-spinner></h4>
          </b-card>
        </div>
        <div class="col-12 col-md-6 mb-3">
          <b-card
            border-variant="primary"
            header="Top Nasabah"
            class="custom-card-header"
            align="center"
          >
            <h3
              v-if="loaded == true"
              v-for="(nasabah, index) in nasabah_populer"
              :key="index"
            >
              - {{ nasabah.name }}
            </h3>
            <h4 v-else><b-spinner variant="warning"></b-spinner></h4>
          </b-card>
        </div>
      </div>

      <!-- <div class="row">
        <div class="col mb-3">
          <b-card>
            <h4>Pertumbuhan Funder</h4>
            <bar-chart :chart-data="datacollection"></bar-chart>
          </b-card>
        </div>
        <div class="col">
          <b-card>
            <h4>Funder Per Produk</h4>
            <pie-chart :chart-data="datacollection"></pie-chart>
          </b-card>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import BarChart from "../BarChart.vue";
import PieChart from "../PieChart.vue";
import Product from "../../api/produk.js";
import BiayaJasa from "../../api/biayajasa.js";
import Pengajuan from "../../api/pengajuan.js";

export default {
  name: "DashboardMitra",
  components: {
    BarChart,
    PieChart
  },
  data() {
    return {
      items: [],
      datacollection: null,
      loaded: false,
      biaya_jasa: 0,
      total_pengajuan: 0,
      total_pengajuan_hari_ini: 0,
      total_nasabah: 0,
      total_pengajuan_proses: 0,
      produk_populer: [],
      nasabah_populer: []
    };
  },
  mounted() {
    this.fillData();
    this.loadData();
    // this.ObjectLength()
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    }
  },
  methods: {
    loadData() {
      Product.productOnMitra(this.currentUser.info.mitra_id)
        .then(res => {
          this.items = res.data.data.data;
          this.loaded = true;
        })
        .catch(err => console.log(err));

      BiayaJasa.thismonth().then(res => {
        // console.log("biaya jasa", res);
        this.biaya_jasa = res.data.data[0].biayas;
      });

      Pengajuan.totalPengajuanMitra().then(res => {
        // console.log(res)
        this.total_pengajuan = res.data.data.data;
      });

      Pengajuan.totalPengajuanMitraHariIni().then(res => {
        // console.log("pengajuan hari ini", res);
        this.total_pengajuan_hari_ini = res.data.data.data;
      });

      Pengajuan.totalPengajuanMitraProses().then(res => {
        // console.log(res.data.data.data.length)
        this.total_pengajuan_proses = res.data.data.data;
      });

      Pengajuan.totalNasabahMitra().then(res => {
        // return length;
        // console.log(res.data)
        this.total_nasabah = res.data;
      });

      Pengajuan.produkPopuler().then(res => {
        // return length;
        // console.log(res.data.data);
        this.produk_populer = res.data.data;
      });

      Pengajuan.nasabahPopuler().then(res => {
        // return length;
        // console.log(res.data.data);
        this.nasabah_populer = res.data.data;
      });
    },
    fillData() {
      this.datacollection = {
        labels: [this.getRandomInt(), this.getRandomInt()],
        datasets: [
          {
            label: "Data One",
            backgroundColor: "#f87979",
            data: [this.getRandomInt(), this.getRandomInt()]
          },
          {
            label: "Data One",
            backgroundColor: "#f87979",
            data: [this.getRandomInt(), this.getRandomInt()]
          }
        ]
      };
    },
    getRandomInt() {
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5;
    }
  }
};
</script>
<style scoped>
.custom-card-header .card-header {
  background-color: #274c8f;
  color: #f6bc3c;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/dashboard-index.vue